import { CoreIcon } from '../core-icon';
import promotionFillSVG from '../../assets/icons/promotion-fill.svg';
import type { IconProps } from '../core-icon';

export const PromotionFillIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={promotionFillSVG} {...props} />;
};
